import axios from "../Config/axios";

export const UseMarketOpportunities = async () => {
  try {
    let respData = await axios({
      method: "get",
      url: `/market/get-opportunities`,
    });

    console.log("UseMarketOpportunities", respData);

    return {
      status: "success",
      loading: false,
      data: respData.data.data,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const UseSchedulesList = async () => {
  try {
    let respData = await axios({ method: "get", url: `/market/get-schedules` });
    return {
      status: "success",
      loading: false,
      data: respData.data.data,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const AddSchedule = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/market/set-schedules`,
      data,
    });
    return {
      status: "success",
      loading: false,
      data: respData.data.data,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const GetPlanInfo = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-subscription-plan`,
      data,
    });
    return {
      status: "success",
      loading: false,
      data: respData.data.data,
      result: respData.data.data,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const AddTransaction = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/add-transactions`,
      data,
    });
    console.log("txFlashloan respData : ", respData.data)
    return {
      status: "success",
      loading: false,
      data: respData.data.data,
      result: respData.data.data,
      message: respData.data.message,
    };
  } catch (err) {
    console.log("Error : ", err)
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const getTransaction = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-Transactions`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
      count: respData.data.count,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const getSchedules = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/market/list-schedules-user`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
      count: respData.data.count,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const editSchedules = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/market/change-schedule-status`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
    };
  }
};

export const AddSupportTicket = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/settingapi/add-Ticket`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
      message: respData.data.message,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
    };
  }
};

export const getsupportTicket = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/settingapi/get-Tickets`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
      message: respData.data.message,
      count: respData.data.count,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      count: err.data.count,
    };
  }
};

export const getTokenOptions = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-dashboard-tokens`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      error: err.response.data,
    };
  }
};

export const convertUSD = async (token) => {
  try {
    const USDPice = await axios.get(
      "https://min-api.cryptocompare.com/data/price?fsym=" +
      token +
      "&tsyms=USD"
    );
    // .then((result) => {
    return {
      status: "Success",
      loading: false,
      data: USDPice.data.USD,
    };
    // });
  } catch (err) {
    return {
      status: "failed",
      loading: false,
    };
  }
};



export const getAllPairs = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-all-pair`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      error: err.response.data,
    };
  }
};



export const getAllExchanges = async (data) => {

  console.log("getAllExchanges", data);

  try {
    let respData = await axios({
      method: "post",
      url: `/currencyapi/get-all-exchange`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      error: err.response.data,
    };
  }
};



export const removePairData = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/choose-pair`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      error: err.response.data,
    };
  }
};


export const removeExchangeData = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/choose-exchange`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      error: err.response.data,
    };
  }
};
export const getUserChooseData = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/userapi/get-userdata`,
      data,
    });
    return {
      status: "success",
      loading: false,
      result: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      error: err.response.data,
    };
  }
};